import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { ToastProvider } from '@orbind/ui'
import '@orbind/ui/styles.css'
import { OrbindApiError } from '@orbind/api-client'
import { I18nProvider } from './lib/i18n.tsx'
import { iniciarZoom } from './lib/zoom.ts'
import { ShellUpdateGate } from './shell/ShellUpdateGate.tsx'
import { PermissaoDeMidia } from './shell/PermissaoDeMidia.tsx'
import { ThemeProvider } from './shell/theme.tsx'
import { router } from './app/router.tsx'
import './styles/app.css'
// modo de cor Black, o escuro do Claude (SPEC-20261103-1932) — depois dos tokens
import './styles/tema-black.css'
// visual novo (definitivo, SPEC-20261007-1409) aplicado antes da primeira tela, inclusive o login
import './features/chat/visual-novo.ts'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // 4xx e erro do pedido, nao instabilidade: repetir so gasta tempo do
      // usuario e mascara o problema real.
      retry: (failureCount, error) => {
        if (error instanceof OrbindApiError && error.status >= 400 && error.status < 500) return false
        return failureCount < 2
      },
    },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('elemento #root nao encontrado')

// zoom da interface: aplica o padrao ao conectar e liga Ctrl +/-/0 e Ctrl+scroll
iniciarZoom()

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <ThemeProvider>
          <ToastProvider>
            <RouterProvider router={router} />
            {/* portao de atualizacao do shell: cobre a tela na abertura se ha
                instalador mais novo (so faz algo no desktop) */}
            <ShellUpdateGate />
            {/* permissão de microfone/câmera perguntada pelo Orbind, sem a
                janela do motor (SPEC-20260916-2335) */}
            <PermissaoDeMidia />
          </ToastProvider>
        </ThemeProvider>
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
)
